import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Quote from "../components/Quote";
import Support from "../components/Support";
import PageTitle from "../components/PageTitle";
import ImportantNews from "../components/ImportantNews";
import FacebookAd from "../components/FacebookAd";
import LatestNews from "../components/LatestNews";
import ImportantNews1 from "../components/ImportantNews1";
import StaraZagora from "../components/StaraZagora";

const Landing = () => {
    return (
        <>
            <PageTitle title='Home' />
            <Header/>
            <div className='main-container'>
                <Hero />
                <FacebookAd />
                <StaraZagora />
                <ImportantNews1 />
                <LatestNews />
                <ImportantNews />
                <Quote />
                <Support />
            </div>
            <Footer/>
        </>

    );
};

export default Landing;